import type { ImgHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

import LogoHorizontalImage from './logo_horizontal.svg'

export const LogoHorizontal = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  const { t } = useTranslation()

  return (
    <img
      src={LogoHorizontalImage}
      alt={t('components.logo.horizontal_logo_alt')!}
      {...props}
    ></img>
  )
}

LogoHorizontal.displayName = 'LogoHorizontal'
